<template>
    <ui-modal icon="far fa-pen-ruler" name="adjustable-installments" title="Reajuste de Parcelas" size="sm">
        <div class="adjustable-installments scroll-color">
            <ui-table :columns="columns" :data="tableData" :loading="false" :table-header-fixed="false"
                :is-fixed-list="true" :last-col-fixed="false" name="AdjustableInstallmentsTable"
                not-found-text="Não foi possível encontrar nenhuma opção." not-found-icon="fa fa-file-contract"
                tr-component="products/step-four/adjustable-installments/table-line" custom-load-area
                :selectColumnMenu="false" @update-readjust="updateReadjust" />
        </div>
        <template #footer>
            <ui-button type="button" design="md success" @click="submitReadjustableInstallments"
                :loading="isProcessing"
                :disabled="requestData === null || Object.keys(requestData).length === 0">
                Salvar
            </ui-button>
        </template>
    </ui-modal>
</template>

<script>
import { uiButton } from "@/components/ui/buttons"
import { uiInput, uiSelectV2 } from "@/components/ui/form"
import { uiModal } from "@/components/ui/modal"
import { uiTable, uiLoadIndicator } from '@/components/ui'

import { salesTable } from "@/services/axios"
import { mapGetters } from 'vuex'

export default {
    name: "adjustable-installmentsss",
    components: {
        uiButton,
        uiModal,
        uiInput,
        uiSelectV2,
        uiTable
    },


    data() {
        return {
            loading: false,
            select: null,
            columns: [
                { title: 'Parcela', size: '50px' },
                { title: 'Reajuste', size: '50px' },
            ],

            sales_table_id: null,
            isProcessing: false,
            requestData: null,
            table_id: null,
        }
    },

    computed: {
        ...mapGetters('salesTable', {
            salesTableDefaultConfig: 'getSalesTableDefaultConfigs',
            salesTable: 'getSalesTable',
        }),
        tableData() {
            return Object.entries(this.salesTableDefaultConfig?.readjust || {}).map(([type, value], index) => ({
                table_id: this.table_id,
                id: index,
                type,
                readjust: value ?? null
            }));
        }
    },

    created() {
        this.$root.$on("modal-open-adjustable-installments", () => {
            this.loading = false
        });

        this.$root.$on('send-data', (data) => {
            if(!data) return
            this.table_id = data.id 

        });
        this.$root.$on('update-flow', this.updatedFlowHandler)
    },

    beforeDestroy() {
        this.$root.$off("modal-open-adjustable-installments");
        this.$root.$off("parcel-has-updated");
        this.$root.$off('update-flow')
    },

    methods: {
        updateReadjust(updatedData) {
            if (!updatedData || updatedData.id === null || !updatedData.type) {
                return;
            }

            this.requestData = {
                ...this.requestData,
                [updatedData.type]: updatedData.readjust
            };

        },

        async submitReadjustableInstallments() {
            this.isProcessing = true

            if (!this.requestData || Object.keys(this.requestData).length === 0) {
                this.isProcessing = false;
                return;
            }

            await salesTable.updateReadjustableInstallments(this.salesTable.id, this.requestData)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.$root.$emit("updated-config", {
                            salesTableId: this.salesTable.id,
                            salesTableDefaultConfig: response.data.data.default_config
                        });
                        this.$store.dispatch('salesTable/setSeriesDefaultConfigs',response.data.data.default_config )
                        this.$toastr.s("Reajuste de Parcelas atualizado com sucesso!")
                    }
                })
                .catch(() => {
                    this.$toastr.e("Erro ao atualizar parcelas reajustáveis")
                }).finally(() => {
                    this.resetProcess()
                });
        },

        updatedFlowHandler(data) {
            const { salesTableId, salesTableItems } = data;
            if (salesTableId !== this.sales_table_id) {
                return;
            }
            this.tableData.forEach(row => {
                const matchingItem = salesTableItems.find(item => item.parcelType === row.type);

                if (matchingItem && matchingItem.type_readjust !== row.readjust) {
                    row.readjust = matchingItem.type_readjust;
                }
            });
        },

        resetProcess() {
            this.isProcessing = false
            this.requestData = null
        }
    },
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>